'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
require('react');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const components_display_Avatar_Avatar = require('../../display/Avatar/Avatar.cjs.js');
require('clsx');
const components_marketing_TestimonialSolo_TestimonialMapping = require('./TestimonialMapping.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TestimonialSolo", {
  root: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[components_marketing_TestimonialSolo_TestimonialMapping.remapDeprecatedColors(backgroundColor)]]};
  `,
  content: react.css`
    ${styleMixins_reset.boxSizing};
    padding: 39px 19px;
    margin: 0 auto;
    text-align: center;
    max-width: 500px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      max-width: 770px;
      padding: 58px 0px;
    }
  `,
  avatarContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 20px;
  `,
  quote: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph3}
    color: ${theme_Colors.Colors.GrayWarm10};
    margin-bottom: 20px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.subHeader1}
    }
  `,
  author: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1Bold}
    margin: 0;
    color: ${theme_Colors.Colors.GrayWarm9};

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.paragraph3Bold}
    }
  `,
  company: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1}
    margin: 0;
    color: ${theme_Colors.Colors.GrayWarm9};

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.paragraph3}
    }
  `
});
const TestimonialSolo = ({ backgroundColor, avatarUrl, hasAuthorAvatar = true, quote, author, company }) => {
  return react.jsx(
    "div",
    { css: Styles.root(backgroundColor), "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.content, "data-zds": true },
      hasAuthorAvatar && react.jsx(
        "div",
        { css: Styles.avatarContainer, "data-zds": true },
        react.jsx(components_display_Avatar_Avatar.Avatar, { "data-testId": "Avatar", name: author, url: avatarUrl, size: "medium" })
      ),
      react.jsx("div", { css: Styles.quote, "data-zds": true }, quote),
      react.jsx("p", { css: Styles.author, "data-zds": true }, author),
      react.jsx("p", { css: Styles.company, "data-zds": true }, company)
    )
  );
};

exports.TestimonialSolo = TestimonialSolo;
//# sourceMappingURL=TestimonialSolo.cjs.js.map
